<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<section
  class="section-consultant-form"
  [formGroup]="formValidation"
  autocomplete="off"
  *ngIf="!subscriptionComplete"
>
  <div class="img-shedule">
    <img src="{{ imagen_banner }}" />
  </div>
  <div class="container-shedule-app">
    <div class="header-shedule-app">
      <div class="icon-header-shedule">
        <i class="bi bi-calendar2-date"></i>
      </div>
      <div class="text-header-shedule">
        <h3>{{ "Consult" | translate }}</h3>
        <p>{{ "YourAppointment" | translate }}</p>
      </div>
    </div>
    <!-- this dropdown only applies to (subaru,dfsk,geely) CHILE -->
    <div
      class="content-dropdown"
      *ngIf="
        (indexbrand === 4 || indexbrand === 5 || indexbrand === 6 ||  indexbrand === 8) &&
        indexCountry === 3
      "
    >
          <h4 
            class="label-input-custom"
            *ngIf="indexbrand === 8" 
          > 
            {{ "SelectBrand" | translate }} 
          </h4>
          <mat-form-field appearance="outline"
          *ngIf="indexbrand === 8" >
            <mat-select
              [ngModel]="BrandsSelect"
              class="selectfomra"
              name="Brand"
              formControlName="Brand"
            >
              <mat-option
                *ngFor="let Brand of Brands"
                [value]="Brand"
                (click)="filterBrand(Brand)"
              >
                {{ Brand.Description }}
              </mat-option>
            </mat-select>
          </mat-form-field>

      <h4 class="label-input-custom">{{ "selectCompany" | translate }}</h4>
      <mat-form-field appearance="outline">
        <mat-select class="selectfomra" name="company" [disabled]="diableDerco"  formControlName="company">
          <mat-option
          
            *ngFor="let company of companies"
            [value]="company"
            (click)="filterCompany(company)"
          >
            {{ company.Description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="content-shedule">
      <div class="form-input">
        <h4 class="label-input-custom" *ngIf="indexCountry === 3">
          {{ "Rut" | translate }}
        </h4>
        <h4 class="label-input-custom" *ngIf="indexCountry === 8">
          {{ "DocumentNo" | translate }}
        </h4>
        <h4
          class="label-input-custom"
          *ngIf="indexCountry !== 3 && indexCountry !== 8"
        >
          {{ "ID" | translate }}
        </h4>
        <mat-form-field appearance="outline">
          <!-- <mat-label *ngIf="indexCountry !== 3 && indexCountry !== 8">
            {{ "ID" | translate }}
          </mat-label>
          <mat-label *ngIf="indexCountry === 3">{{
            "Rut" | translate
          }}</mat-label>
          <mat-label class="styleLabel" *ngIf="indexCountry === 8">
            {{ "DocumentNo" | translate }}
          </mat-label> -->
          <input
            matInput
            autocomplete="off"
            formControlName="document"
            maxlength="16"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            [placeholder]="getPlaceholder(indexCountry) | translate"
          />
        </mat-form-field>
        <div *ngIf="indexCountry === 3">
          <p class="mensagePatentModel">
            {{ "Example" | translate }}: 1111111-1
          </p>
        </div>
        <div
          *ngIf="
            cedulaControl?.invalid &&
            (cedulaControl?.touched || cedulaControl?.dirty)
          "
        >
          <p class="error-ms" *ngIf="cedulaControl.errors?.['required']">
            {{ "TheFieldIsRequired" | translate }}
          </p>
          <p class="error-ms" *ngIf="cedulaControl.errors?.['pattern']">
            {{ "OnlyAlphanumericCharacters" | translate }}
          </p>
          <p class="error-ms" *ngIf="cedulaControl.errors?.['minlength']">
            {{ "MinimumFiveCharacters" | translate }}
          </p>
        </div>
      </div>
      <div class="form-input">
        <h4 class="label-input-custom" *ngIf="indexCountry === 8">
          {{ "LicensePlate" | translate }}
        </h4>
        <h4
          class="label-input-custom"
          *ngIf="indexCountry !== 3 && indexCountry !== 8"
        >
          {{ "Plate" | translate }}
        </h4>
        <h4 class="label-input-custom" *ngIf="indexCountry === 3">
          {{ "Patent" | translate }}
        </h4>
        <mat-form-field appearance="outline">
          <!-- <mat-label *ngIf="indexCountry !== 3 && indexCountry !== 8">
            {{ "Plate" | translate }}
          </mat-label>
          <mat-label *ngIf="indexCountry === 3">{{
            "Patent" | translate
          }}</mat-label>
          <mat-label class="styleLabel" *ngIf="indexCountry === 8">{{
            "LicensePlate" | translate
          }}</mat-label> -->
          <input
            matInput
            type="text"
            name="placa"
            formControlName="placa"
            autocomplete="off"
            [disabled]="true"
            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
            maxlength="16"
            [placeholder]="getPlatePlaceholder(indexCountry) | translate"
          />
        </mat-form-field>
        <div *ngIf="indexCountry === 3">
          <p class="mensagePatentModel">{{ "Example" | translate }}: AABB12</p>
        </div>
        <div
          *ngIf="
            placaControl?.invalid &&
            (placaControl?.touched || placaControl?.dirty)
          "
        >
          <p class="error-ms" *ngIf="placaControl.errors?.['required']">
            {{ "TheFieldIsRequired" | translate }}
          </p>
        </div>
      </div>
    </div>
    <div class="Spinner" *ngIf="loadingSerchPlate">
      <mat-spinner></mat-spinner>
    </div>
    <div class="btn-container">
      <button
        mat-raised-button
        color="primary"
        class="btn-consultant"
        type="button"
        (click)="onplateNumberSearchClick()"
        [disabled]="formValidation.invalid"
      >
        {{ "Search" | translate | uppercase }}
      </button>

      <button class="btn-clean" mat-raised-button (click)="onClearClick()">
        {{ "Clean" | translate | uppercase }}
      </button>
    </div>
  </div>
</section>

<section class="section-consultant-check" *ngIf="subscriptionComplete">
  <div class="container-consultant-check">
    <div class="consultant-check">
      <div class="icon-consultant-check">
        <i class="bi bi-calendar2-date"></i>
      </div>
      <div class="text-consultant-check">
        <h3>{{ "Consult" | translate }}</h3>
        <p>{{ "YourAppointment" | translate }}</p>
      </div>
    </div>
    <h3 class="text-consultant">
      {{ "Hi" | translate }}, {{ scheduledAppointments[0].CustomerName }}
      {{ "YouHave" | translate }} {{ scheduledAppointmentsNumber }}
      {{ "AppointmentsScheduled" | translate }}:
    </h3>

    <section *ngIf="!isAppointmentCanceled">
      <div
        class="card-consultant-check"
        *ngFor="let appointment of visibleAppointments; let i = index"
      >
        <div class="content-card-consultant-check">
          <div class="content-text">
            <div class="card-text-check">
              <h1>{{ "MyReservation" | translate }}</h1>
              <div class="line"></div>
            </div>
            <div class="content-card-text-consultant-check">
              <div class="item-card-consultant">
                <p>{{ "TypeOfService" | translate }}</p>
                <h2>{{ appointment.Services[0].ServiceName | translate }}</h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "Mileage" | translate }}</p>
                <h2>
                  {{ appointment.Mileage }}
                </h2>
              </div>
              <div class="item-card-consultant"   *ngIf=" indexbrand === 8 ">
                <p>{{ "Brand" | translate }}</p>
                <h2>
                  {{ appointment.Make}}
                </h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "City" | translate }}</p>
                <h2>{{ appointment.LocationName }}</h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "Workshop" | translate }}</p>
                <h2>{{ appointment.CompanyName }}</h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "Advisor" | translate }}</p>
                <h2>{{ appointment.Resources[0].ResourceName }}</h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "Date" | translate }}</p>
                <h2>{{ appointment.startDate }}</h2>
              </div>
              <div class="item-card-consultant">
                <p>{{ "Time" | translate }}</p>
                <h2>{{ appointment.time }}</h2>
              </div>
            </div>
          </div>
          <div class="content-card-consultant-check-btn" [ngClass]="{ 'content-card-consultant-check-btn-disabled': isDisabledAppointment(scheduledAppointments[i]) }">
            <button
              mat-raised-button
              class="btn-card-consultant"
              (click)="editSchedule(scheduledAppointments[i])"
             >
              <!-- <img src="../../../../assets/reagendar-icon.svg" alt="" /> -->
              <svg
                width="41"
                height="36"
                viewBox="0 0 41 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.25 0C9.94036 0 10.5 0.503142 10.5 1.1238V2.2476H30.5V1.1238C30.5 0.503142 31.0596 0 31.75 0C32.4404 0 33 0.503142 33 1.1238V2.2476H35.5C38.2614 2.2476 40.5 4.26016 40.5 6.74279V31.4663C40.5 33.949 38.2614 35.9615 35.5 35.9615H5.5C2.73858 35.9615 0.5 33.949 0.5 31.4663V6.74279C0.5 4.26016 2.73858 2.2476 5.5 2.2476H8V1.1238C8 0.503142 8.55964 0 9.25 0ZM5.5 4.49519C4.11929 4.49519 3 5.50148 3 6.74279V8.99039H38V6.74279C38 5.50148 36.8807 4.49519 35.5 4.49519H5.5ZM38 11.238H3V31.4663C3 32.7077 4.11929 33.7139 5.5 33.7139H35.5C36.8807 33.7139 38 32.7077 38 31.4663V11.238Z"
                  fill="white"
                />
                <path
                  d="M28 16.857C28 16.2363 28.5596 15.7332 29.25 15.7332H31.75C32.4404 15.7332 33 16.2363 33 16.857V19.1045C33 19.7252 32.4404 20.2283 31.75 20.2283H29.25C28.5596 20.2283 28 19.7252 28 19.1045V16.857Z"
                  fill="white"
                />
                <path
                  d="M20.5 16.857C20.5 16.2363 21.0596 15.7332 21.75 15.7332H24.25C24.9404 15.7332 25.5 16.2363 25.5 16.857V19.1045C25.5 19.7252 24.9404 20.2283 24.25 20.2283H21.75C21.0596 20.2283 20.5 19.7252 20.5 19.1045V16.857Z"
                  fill="white"
                />
                <path
                  d="M15.5 23.5997C15.5 22.9791 16.0596 22.4759 16.75 22.4759H19.25C19.9404 22.4759 20.5 22.9791 20.5 23.5997V25.8473C20.5 26.468 19.9404 26.9711 19.25 26.9711H16.75C16.0596 26.9711 15.5 26.468 15.5 25.8473V23.5997Z"
                  fill="white"
                />
                <path
                  d="M8 23.5997C8 22.9791 8.55964 22.4759 9.25 22.4759H11.75C12.4404 22.4759 13 22.9791 13 23.5997V25.8473C13 26.468 12.4404 26.9711 11.75 26.9711H9.25C8.55964 26.9711 8 26.468 8 25.8473V23.5997Z"
                  fill="white"
                />
              </svg>

              <p>{{ "ReSchedule" | translate }}</p>
            </button>

            <button
              mat-raised-button
              class="btn-card-consultantCancel"
              (click)="openDialog(scheduledAppointments[i])"
             
            >
              <!-- <i class="material-icons-outlined">event_busy</i> -->
              <!-- <img
                src="../../../../assets/cancel-schedule-icon.svg"
                alt="cancel schedule icon"
              /> -->
              <svg
                width="41"
                height="37"
                viewBox="0 0 41 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.8661 18.6689C16.3543 18.2215 17.1457 18.2215 17.6339 18.6689L20.5 21.2962L23.3661 18.6689C23.8543 18.2215 24.6457 18.2215 25.1339 18.6689C25.622 19.1164 25.622 19.8419 25.1339 20.2894L22.2678 22.9167L25.1339 25.5439C25.622 25.9914 25.622 26.7169 25.1339 27.1644C24.6457 27.6119 23.8543 27.6119 23.3661 27.1644L20.5 24.5371L17.6339 27.1644C17.1457 27.6119 16.3543 27.6119 15.8661 27.1644C15.378 26.7169 15.378 25.9914 15.8661 25.5439L18.7322 22.9167L15.8661 20.2894C15.378 19.8419 15.378 19.1164 15.8661 18.6689Z"
                  fill="#0078D6"
                />
                <path
                  d="M9.25 0C9.94036 0 10.5 0.513007 10.5 1.14583V2.29167H30.5V1.14583C30.5 0.513007 31.0596 0 31.75 0C32.4404 0 33 0.513007 33 1.14583V2.29167H35.5C38.2614 2.29167 40.5 4.34369 40.5 6.875V32.0833C40.5 34.6146 38.2614 36.6667 35.5 36.6667H5.5C2.73858 36.6667 0.5 34.6146 0.5 32.0833V6.875C0.5 4.3437 2.73858 2.29167 5.5 2.29167H8V1.14583C8 0.513007 8.55964 0 9.25 0ZM5.5 4.58333C4.11929 4.58333 3 5.60935 3 6.875V32.0833C3 33.349 4.11929 34.375 5.5 34.375H35.5C36.8807 34.375 38 33.349 38 32.0833V6.875C38 5.60935 36.8807 4.58333 35.5 4.58333H5.5Z"
                  fill="#0078D6"
                />
                <path
                  d="M6.75 9.16667C6.75 8.53384 7.30964 8.02083 8 8.02083H33C33.6904 8.02083 34.25 8.53384 34.25 9.16667V11.4583C34.25 12.0912 33.6904 12.6042 33 12.6042H8C7.30964 12.6042 6.75 12.0912 6.75 11.4583V9.16667Z"
                  fill="#0078D6"
                />
              </svg>

              <p>{{ "CancelAppointment" | translate }}</p>
            </button>
          </div>
        </div>
      </div>
      <div class="box-view-more" *ngIf="this.scheduledAppointmentsNumber >= 20">
          <button *ngIf="hasMoreAppointments" (click)="fetchMoreAppointments()" class="btn-view-more">
           {{ "ViewMore" | translate | capitalize }}... 
          </button>
        </div>
    </section>

    <div *ngIf="isAppointmentCanceled" class="canceled">
      <div class="check"></div>
      <p class="canceled-text">
        <strong>{{
          "CancelSuccessMsg"
            | translate : { typeOfService: typeOfService | translate }
        }}</strong>
      </p>
      <p class="canceled-ty">{{ "BannerSucces1" | translate | capitalize }}</p>
    </div>
  </div>
</section>
